const getProductDescription = (product, useFallback = false) =>
  product.description
    ? product.description.shortPlainText ||
      (useFallback && product.description.longPlainText) ||
      null
    : null;
export default getProductDescription;
